import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseInput = ({ iconLeft, iconRight, error, className, ...props }) => {
    return (_jsxs("label", { className: `akui-input ${props.disabled ? "input-disabled" : ""} ${error ? "input-error" : ""} ${className ?? ""}`, children: [iconLeft, _jsx("input", { ...props, className: "text-base sm:text-sm" }), iconRight] }));
};
// this isn't used externally
// eslint-disable-next-line jsdoc/require-jsdoc
export const Input = ({ label, hint, ...props }) => {
    if (label || hint || props.error) {
        return (_jsxs("label", { className: "akui-form-controls", children: [label && _jsx("span", { className: "akui-form-label", children: label }), _jsx(BaseInput, { ...props }), (props.error ?? hint) && (_jsx("span", { className: "akui-form-hint", children: props.error ?? hint }))] }));
    }
    return _jsx(BaseInput, { ...props });
};
//# sourceMappingURL=input.js.map